const styles = () => ({
  grid: {
    marginTop: '40px',
  },
});

export default styles;
